
import TimeUnit from "./TimeUnit.js";
import DateUtils from "@/utils/DateUtils.js";

/** A minute of the day, mirroring com.readychek.time.RcMinute. Arithmetic is immutable. */
export default class RcMinute extends TimeUnit {

  constructor(date, timeZone) {
    super(date, timeZone);
  }

  value() {
    return this.minute();
  }

  next() {
    return this.add(1);
  }

  previous() {
    return this.add(-1);
  }

  add(minutes) {
    return new RcMinute(new Date(this.time() + DateUtils.minutes(minutes)), this.timeZone());
  }

  subtract(minutes) {
    return new RcMinute(new Date(this.time() - DateUtils.minutes(minutes)), this.timeZone());
  }
}
